@if (data.title) {
  <h2 mat-dialog-title>{{ data.title }}</h2>
}

<mat-dialog-content>
  <ng-container
    *ngTemplateOutlet="data.template; context: { $implicit: data.context, close: close.bind(this) }"
  ></ng-container>
</mat-dialog-content>

@if (data.showFooter !== false) {
  <mat-dialog-actions align="end">
    @for (btn of data.buttons; track btn.label) {
      <button
        mat-button
        [class]="btn.color"
        [disabled]="btn.disabled"
        [type]="btn.type || 'button'"
        (click)="handleButtonClick(btn)"
      >
        {{ btn.label }}
      </button>
    }
  </mat-dialog-actions>
}
